export default __webpack_public_path__ + "static/media/aboutus.2b409822.png";